import React, { Component } from "react";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import Icon from "../../common/Icon";
import Badge from "../badge/Badge";
import OrderBox from "../../orders/orderBox/OrderBox";
import styles from "./OrderTable.scss";

class OrderTable extends Component {
  ordersNav(poNr) {
    this.props.onOrderSelect
      ? this.props.onOrderSelect(poNr)
      : this.props.history.push(`/${Helper.getLocale()}/orders/${poNr}`);
  }
  render() {
    const data = this.props.data || "";

    const dir = this.props.dir && this.props.dir === "asc" ? "desc" : "asc";

    const orderList = data
      ? data.map((order, index) => {
          return (
            <tr
              className={`${styles.row} ${styles[order.status.toLowerCase()]}`}
              onClick={() => this.ordersNav(order.po_nr || order.poNr)}
              key={index}
            >
              <td>
                <div
                  className={`${styles.status} ${
                    order.isNew ? styles.new : ""
                  } ${
                    styles[
                      order.status
                        .toLowerCase()
                        .split(" ")
                        .join("_")
                    ]
                  }`}
                >
                  {order.status}
                </div>
              </td>
              <td style={{ direction: "ltr" }}>
                {order
                  ? moment(order.created_at || order.createdAt).format(
                      `YYYY-MM-DD [${
                        this.props.lang === "ar" ? "" : "at"
                      }] h:mm:ss a`
                    )
                  : ""}
              </td>
              <td>{order ? order.po_nr || order.poNr : ""}</td>
              <td>
                {order.business_model === "Fulfilled by noon" ||
                order.fulfillmentMethod === "Fulfilled by noon" ||
                order.isFbn ? (
                  <Badge />
                ) : order.business_model === "Seller B2B" ||
                order.fulfillmentMethod === "Seller B2B" ? (
                  <Badge sellerB2B />
                ) : (
                  order.business_model || order.fulfillmentMethod
                )}
              </td>
              <td>{order.quantity}</td>
              <td>
                {I18n.formatCurrency(
                  Helper.formatPrice(order.total, this.props.currencyCode)
                )}
              </td>
            </tr>
          );
        })
      : "";

    const orderBox = data
      ? data.map((order, index) => {
          return (
            <div
              className={styles.boxWrapper}
              key={index}
              onClick={() => this.ordersNav(order.po_nr || order.poNr)}
            >
              <OrderBox
                order={order}
                lang={this.props.lang}
                currencyCode={this.props.currencyCode}
              />
            </div>
          );
        })
      : "";
    return (
      <div className={styles.ctr}>
        {this.props.browser && this.props.browser.greaterThan.tablet ? (
          <table className={styles.table}>
            <thead>
              <tr className={`${styles.row} ${styles.head}`}>
                <th>
                  {I18n.getText("order.order-table-status", {}, "Status")}
                </th>
                <th
                  className={styles.titleFlexer}
                  onClick={
                    this.props.sortColumn
                      ? () => this.props.sortColumn("created_at", dir)
                      : () => {}
                  }
                >
                  {I18n.getText("order.order-table-date", {}, "Date & Time")}
                  {this.props.keyVal && this.props.keyVal === "created_at" ? (
                    <Icon name={dir === "asc" ? "caret-down" : "caret-up"} />
                  ) : (
                    <Icon name={"caret-both"} />
                  )}
                </th>
                <th>
                  {I18n.getText("order.order-table-p-number", {}, "Po Number")}
                </th>
                <th>
                  {I18n.getText(
                    "order.order-table-fullfillment",
                    {},
                    "Fullfillment Method"
                  )}
                </th>
                <th
                  className={styles.titleFlexer}
                  onClick={
                    this.props.sortColumn
                      ? () => this.props.sortColumn("quantity", dir)
                      : () => {}
                  }
                >
                  {I18n.getText("order.order-table-qty", {}, "Quantity")}
                  {this.props.keyVal && this.props.keyVal === "quantity" ? (
                    <Icon name={dir === "asc" ? "caret-down" : "caret-up"} />
                  ) : (
                    <Icon name={"caret-both"} />
                  )}
                </th>
                <th
                  className={styles.titleFlexer}
                  onClick={
                    this.props.sortColumn
                      ? () => this.props.sortColumn("total", dir)
                      : () => {}
                  }
                >
                  {I18n.getText("order.order-table-total", {}, "Total")}
                  {this.props.keyVal && this.props.keyVal === "total" ? (
                    <Icon name={dir === "asc" ? "caret-down" : "caret-up"} />
                  ) : (
                    <Icon name={"caret-both"} />
                  )}
                </th>
              </tr>
            </thead>
            <tbody>{orderList}</tbody>
          </table>
        ) : (
          orderBox
        )}
      </div>
    );
  }
}

export default OrderTable;



// WEBPACK FOOTER //
// ./src/components/common/orderTable/OrderTable.js